<app-order-id *app-table-column="let order; name:'id'; converter: orderConverter"
              [link]="orderLink.concat([order.id])"
              [skeletonView]="(projectLoading$ | async) || tableLoading"
              [order]="order">
</app-order-id>

<app-recipient-primary *app-table-column="let order; name:'recipient'; converter: orderConverter"
                       [skeletonView]="(projectLoading$ | async) || tableLoading"
                       [order]="order">
</app-recipient-primary>

<app-cart *app-table-column="let order; name:'cart'; converter: orderConverter"
          [skeletonView]="(projectLoading$ | async) || tableLoading"
          [order]="order">
</app-cart>

<app-order-dates *app-table-column="let order; name:'dates'; converter: orderConverter"
                 [skeletonView]="(projectLoading$ | async) || tableLoading"
                 [order]="order">
</app-order-dates>

<app-unloading-view *app-table-column="let order; name:'courier'; converter: orderConverter"
                    [skeletonView]="(projectLoading$ | async) || tableLoading"
                    [order]="order">
</app-unloading-view>

<app-tracking *app-table-column="let order; name:'tracking'; converter: orderConverter"
              [skeletonView]="(projectLoading$ | async) || tableLoading"
              [link]="orderLink.concat([order.id])"
              [order]="order">
</app-tracking>

<app-current-status *app-table-column="let order; name:'status'; converter: orderConverter"
                    [skeletonView]="(projectLoading$ | async) || tableLoading"
                    [order]="order">
</app-current-status>

<app-storehouse-view *app-table-column="let order; name:'store'; converter: orderConverter"
                     [order]="order"
                     [skeletonView]="(projectLoading$ | async) || tableLoading">
</app-storehouse-view>

<ng-container *app-table-column="let order; name:'comment'; converter: orderConverter">
  {{ order.comment }}
</ng-container>

<app-additional-fields *app-table-column="let order; name:'additions'; converter: orderConverter"
                       [skeletonView]="(projectLoading$ | async) || tableLoading"
                       [order]="order">
</app-additional-fields>
